import { SeriesPrimitivePaneViewZOrder } from 'lightweight-charts'
import DrawingPaneView from '../drawing.paneView'

class SessionBreakPaneView extends DrawingPaneView {
    zOrder(): SeriesPrimitivePaneViewZOrder {
        return 'bottom'
    }
}

export default SessionBreakPaneView
